import {useBehavioralContext, useAppContext} from "../../../../contexts";
import AttendancePicker from "./AttendancePicker";
import {Fragment, h} from "preact";
import s from "./picker.module.css";
import {usePicker} from "./usePicker";
import {validateAttendances} from "./picker.helper";

const Picker = (props) => {
    // Destructured props
    const {
        handleCurrentStep,
        handleCartLoader
    } = props;

    // Component logic data
    const componentProps = usePicker();

    // Destructured component logic data
    const {
        sidebarCartData,
        selectedAttendanceType,
        availableAttendanceTypes,
        isComponentReady,
        hasOnlyOneAttendanceType,
        handleAttendance
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Retrieves product data
    const {
        productData,
        setOpenTermUse,
        productCategoryServiceType
    } = sidebarCartData.newProductData;

    // Prevents unnecessary errors
    if (Object.keys(sidebarCartData.newProductData).length === 0) {
        return null;
    }

    // Variable containing all the available attendance types components
    const attendances = availableAttendanceTypes.map(attendance => {
        return (
            <AttendancePicker
                key={attendance.id}
                attendance={attendance}
                selectedAttendanceType={selectedAttendanceType}
                handleAttendance={handleAttendance}
                singleAttendanceType={hasOnlyOneAttendanceType}
                formKey={productData.formKey}
                product={productData.product}
                categories={productData.product.categories}
                setOpenTermUse={setOpenTermUse}
                globalFreeFreight={productData.globalFreeFreight}
                productCategoryServiceType={productCategoryServiceType}
                handleCartLoader={handleCartLoader}
                handleCurrentStep={handleCurrentStep}
                sidebarCartData={sidebarCartData}
            />
        )
    })

    // Main content variable
    const content = (
        isComponentReady &&
        validateAttendances(availableAttendanceTypes)
    ) ? (
        <p className={`${s.attendanceTitle} ${highContrast ? "highTitleThird" : ""}`}>
            Não há nenhuma opção de atendimento disponível para o produto selecionado.
        </p>
    ) : (
        <Fragment>
            <p className={`mb-3 ${s.attendanceTitle} ${highContrast ? "!text-white" : ""}`}>
                Escolha o atendimento
            </p>
            <div className={"flex flex-col gap-y-3"}>
                {attendances}
            </div>
        </Fragment>
    )

    return (
        <div className={`font-museo ${s.root}`}>
            <div className={"rounded-3xl border p-3 md:p-5"}>
                <h1 className={`text-[16px] md:text-[20px] text-sabin-red-default font-bold mb-5 ${highContrast ? "highTitleThird" : ""}`}>
                    {productData.product.name}
                </h1>
                {content}
            </div>
        </div>
    )
}

export default Picker;
